import capitalize from 'lodash/capitalize';

type SentenceCase = (str: string | undefined | null) => string;

/**
 * Converts a string from any casing convention to use sentence case
 * (i.e. w/ only the first letter capitalized).
 */
export const sentenceCase: SentenceCase = (str) =>
  str ? capitalize(str.toLowerCase().replace(/[-_]/g, ' ')) : '';

export const pluralize = (count: number | undefined, noun: string) => {
  if (count === undefined || count === 1) {
    return noun;
  }

  return `${noun}s`;
};
